var robotHost
if (document.domain === 'www.bjsjsadr.com') {
  robotHost = 'https://dfszjidprobot.odrcloud.cn/'
} else if (document.domain === 'hnodr.hainan.gov.cn') {
  robotHost = 'https://dfszjidprobot.odrcloud.cn/'
} else if (document.domain === 'devhnswodr.odrcloud.cn') {
  robotHost = 'https://dfszjidprobot.odrcloud.cn/'
} else {
  // robotHost = 'https://testgznetrobot.odrcloud.cn/'
  robotHost = 'https://dfszjidprobot.odrcloud.cn/'
}

export default {
  robotHost: robotHost
}



// WEBPACK FOOTER //
// ./src/publicResource/config/robot.js